/**
 * React Query hooks for Payment
 */

import { useQuery } from "@tanstack/react-query";
import { paymentService } from "../services/payment.service";

export const usePaymentOrder = (orderId: string | null) => {
  return useQuery({
    queryKey: ["paymentOrder", orderId],
    queryFn: () => paymentService.getOrderByOrderId(orderId!),
    enabled: !!orderId && orderId.length > 0,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};

